import { NuxtAxiosInstance } from 'vue/types/vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import { AxiosRequestConfig } from 'axios';
import axios from '@/api/request';
/*
 * @description: description
 * @author: xq
 */

// export interface AIChatMessageResData {
//     messageType?: string;
//     senderRole?: string;
//     senderId?: string;
//     content?: string;
//     contentType?: string;
//     messageId?: string;
//     repayId?: string;
//     extraInfo?: string;
//     index?: number;
//     finished?: boolean;
// }

export interface AIChatMessageResExtraData {
    toolName?: string;
    toolArgs?: string;
    toolResponse?: string;
    toolCallId?: string;
    timeCost?: number;
    inputTokens?: number;
    outputTokens?: number;
}

export const enum AIChatBeginResEventKey {
    chatMessageGenerating = 'CHAT_MESSAGE_GENERATING',
    knowledgeQuerying = 'KNOWLEDGE_QUERYING',
    knowledgeQueried = 'KNOWLEDGE_QUERIED',
    chatStreamEnd = 'CHAT_STREAM_END',
    chatContentFilter = 'CHAT_CONTENT_FILTER',
}

export enum AIChatBeginResEventContentType {
    UNKNOWN_CONTENT = 'UNKNOWN_CONTENT',
    TEXT = 'TEXT',
    MIX_CARD = 'MIX_CARD',
}

export interface AIChatMessageResData {
    // eslint-disable-next-line no-use-before-define
    type?: AIChatBeginResEventKey;
    messageId?: string;
    runId?: string;
    sessionId?: number;
    senderId?: string;
    // eslint-disable-next-line no-use-before-define
    contentType?: AIChatBeginResEventContentType;
    content?: string;
    extraInfo?: AIChatMessageResExtraData;
    index?: number;
}

export const enum AIChatMessageResStatus {
    START = 'start',
    MESSAGE = 'message',
    END = 'end',
    USER_ERROR = 'user_error',
    BOT_ERROR = 'bot_error',
    ABORT = 'abort',
}

export interface ExtraMessage extends Omit<AIChatMessageResData, 'messageType'> {
    pluginList?: ExtraMessage[];
    messageType?: AIChatMessageResData['type'] | 'PLUGIN_LIST';
}

export interface AIChatMessagePart {
    key: string;
    time: string;
    isError?: boolean;
    errorType?: AIChatMessageResStatus;
    entryQuestion?: string;
    role: 'BOT' | 'USER' | 'CLEAR_LINE';
    messageList: ExtraMessage[];
}

export enum AIChatMessageEventType {
    ready = 'ready',
    generating = 'generating',
    end = 'end', // 内容返回结束
    close = 'close', // 断开连接
    filtered = 'filtered',
    error = 'error',
    abort = 'abort',
}

export type omMessageCallback = (id: string, eventType: AIChatMessageEventType) => void;

interface AIChatConnectionInfo {
    id: string;
    waitConsumeList: Array<{ status: AIChatMessageResStatus; data?: AIChatMessageResData }>;
    eventSource?: EventSource;
    onMessage?: omMessageCallback;
    streamingId?: number;
    botId?: string;
    retried?: boolean;
}

export interface AIChatReqOptions {
    botId: string;
    streamingId?: number;
    onMessage?: omMessageCallback;
}

// begin chat
export enum AIChatBeginResChannel {
    unknownChannel = 0,
    kwaiWeb = 9,
}

export enum AIChatBeginResContentProto {
    ccUnknown = 0,
    ccText = 1,
    ccImage = 2,
}

interface AIChatBeginRequestContent {
    type?: AIChatBeginResContentProto;
    text?: string;
    resourceUri?: string;
    mimeType?: string;
    base64Data?: string;
}

interface AIChatBeginRequest {
    botId: string;
    sessionId: string;
    bizUserId?: string;
    channel: AIChatBeginResChannel;
    contents?: AIChatBeginRequestContent[];
    needSensitive: boolean;
}

// chat send messages
// interface AIChatSendMessageRequestContent {
//     type?: string;
//     text?: string;
//     imageUrl?: string;
// }

// interface AIChatSendMessageRequestInner {
//     botId?: string;
//     conversationId?: string;
//     question?: string;
//     name?: string;
//     username?: string;
//     content?: AIChatSendMessageRequestContent[];
// }

interface AIChatSendMessageRequest {
    request?: AIChatBeginRequest;
    streaming?: boolean;
}

export interface AIChatResponseBase {
    result?: number;
    status?: number;
    podName?: string;
    message?: string;
    traceId?: string;
    timestamp?: string;
    landId?: string;
}

export interface AIChatBeginStreamingResponse extends AIChatResponseBase {
    data?: number;
    error_msg?: string;
}

/**
 * Api AIChatConnectionsHandler
 *
 */

export class AIChatConnectionsHandler {
    private maxConnectionNum: number;

    private currentConnectionNum: number;

    private connectionPool: Map<string, AIChatConnectionInfo>;

    private reqWaitingList: Array<
        {
            id: string;
        } & AIChatReqOptions
    >;

    private $axios?: NuxtAxiosInstance;

    public constructor() {
        this.maxConnectionNum = 10;
        this.currentConnectionNum = 0;
        this.connectionPool = new Map();
        this.reqWaitingList = [];
        this.$axios = axios;
    }

    public createConnection = (id: string, options: AIChatReqOptions) => {
        if (!this.connectionPool.has(id) && !this.reqWaitingList.find(i => i.id === id)) {
            this.reqWaitingList.push({ id, ...options });
            this._createConnection();
        }
        return this.abortConnection(id);
    };

    public readAIChunk = (id: string) => {
        const currentConnection = this.connectionPool.get(id);
        return currentConnection;
    };

    // create a connection
    private _createConnection = async () => {
        const req = this.reqWaitingList.shift();
        this.currentConnectionNum += 1;
        req && this.sendChatRequest(req);
    };

    // begin chat with ai sse
    public async createAIChatConnection(id: string, data: AIChatBeginRequest, onMessage?: omMessageCallback, config?: AxiosRequestConfig) {
        const res = await this._preCreateAIChatConnection({ request: data, streaming: true }, config);
        this.createConnection(id, {
            botId: data.botId || '',
            streamingId: res?.data || 0,
            onMessage,
        });
        return res;
    }

    private async _preCreateAIChatConnection(
        data: AIChatSendMessageRequest,
        config?: AxiosRequestConfig,
        retryCount = 0
    ): Promise<AIChatBeginStreamingResponse | undefined> {
        const maxRetries = 2;
        const res = await this.$axios?.$$post?.<AIChatBeginStreamingResponse>(`/rest/o/w/pwa/aifeed/bots/chat`, data, config);

        if (res?.result !== undefined && res.result >= 0) {
            return res;
        }

        if (retryCount >= maxRetries) {
            return res;
        }

        // Wait for a short time before retrying (500ms, 1000ms, 1500ms)
        await new Promise(resolve => setTimeout(resolve, 500 * (retryCount + 1)));

        return this._preCreateAIChatConnection(data, config, retryCount + 1);
    }

    // send a long connection
    private sendChatRequest = async ({
        id,
        streamingId,
        onMessage,
        botId,
        isRetry = false,
    }: { id: string } & AIChatReqOptions & { isRetry?: boolean }) => {
        const initConnection: AIChatConnectionInfo = {
            id,
            waitConsumeList: [],
            streamingId,
            botId,
            retried: isRetry,
        };
        this.connectionPool.set(id, initConnection);
        if (!streamingId) {
            return;
        }

        initConnection.eventSource = new EventSource(`/rest/o/w/pwa/aifeed/bots/chatStreaming?streamingId=${streamingId}`);
        initConnection.onMessage = onMessage;

        initConnection.eventSource.addEventListener('message', this.onMessageHandle(initConnection));
        initConnection.eventSource.addEventListener('open', this.onOpenHandle(initConnection));
        initConnection.eventSource.addEventListener('error', this.onErrorHandle(initConnection));
        initConnection.eventSource.addEventListener('exception', this.onExceptionHandle(initConnection));
        console.log('social-ai-sse', 'sendChatRequest');

        // initConnection.eventSource.addEventListener('done', this.onDoneHandle(initConnection));
        // initConnection.eventSource.addEventListener('msg', this.onMsgeHandle(initConnection));
        // initConnection.eventSource.addEventListener('close', this.onCloseHandle(initConnection));
    };

    private abortConnection = (id: string) => () => {
        if (this.connectionPool.has(id)) {
            const connectionInfo = this.connectionPool.get(id) as AIChatConnectionInfo;
            connectionInfo.eventSource?.close();
            connectionInfo.waitConsumeList.unshift({ status: AIChatMessageResStatus.ABORT });
        } else {
            this.reqWaitingList = this.reqWaitingList.filter(p => p.id !== id);
        }
    };

    public clearSingleConnection = (id: string) => {
        this.currentConnectionNum -= 1;
        this.abortConnection(id);
        if (this.connectionPool.has(id)) {
            this.connectionPool.delete(id);
        }
    };

    public hasValidChatMessage(id: string) {
        const connection = this.readAIChunk(id);
        return !!connection && connection?.waitConsumeList?.some(item => item.status === AIChatMessageResStatus.MESSAGE);
    }

    public readoutAIChatMessage(id: string) {
        const connectionInfo = this.readAIChunk(id);
        let message;
        if (connectionInfo?.waitConsumeList) {
            const targetMessage = connectionInfo.waitConsumeList.find(item => {
                if (item?.status === AIChatMessageResStatus.MESSAGE && item?.data?.type === AIChatBeginResEventKey.chatMessageGenerating) {
                    return true;
                }
                return false;
            });
            if (targetMessage) {
                connectionInfo.waitConsumeList.splice(connectionInfo.waitConsumeList.indexOf(targetMessage), 1);
                message = targetMessage?.data?.content;
            }
        }
        return message;
    }

    public generateLuigiId = (botId?: string, conversationId?: string, messageId?: string) => {
        if (!botId || !conversationId || !messageId) return;
        return `${botId}-${conversationId}-${messageId}`;
    };

    public disposeChat = (luigiId?: string) => {
        if (!luigiId) return;
        this.clearSingleConnection(luigiId);
    };

    // callbacks
    private onOpenHandle = (connectionInfo: AIChatConnectionInfo) => (event: MessageEvent<any>) => {
        connectionInfo.waitConsumeList.push({
            status: AIChatMessageResStatus.START,
        });
        console.log('social-ai-sse', '==== Open');
    };

    private onMessageHandle = (connectionInfo: AIChatConnectionInfo) => (event: MessageEvent<any>) => {
        try {
            const data = JSON.parse(event.data) as string;
            const dataObj = JSON.parse(data) as AIChatMessageResData;
            connectionInfo.waitConsumeList.push({
                status: AIChatMessageResStatus.MESSAGE,
                data: dataObj,
            });

            // eslint-disable-next-line no-use-before-define
            if (dataObj?.type === AIChatBeginResEventKey.knowledgeQueried) {
                if (connectionInfo.onMessage) {
                    connectionInfo.onMessage(connectionInfo.id, AIChatMessageEventType.ready);
                }
                // eslint-disable-next-line no-use-before-define
            } else if (dataObj?.type === AIChatBeginResEventKey.chatMessageGenerating) {
                if (connectionInfo.onMessage) {
                    connectionInfo.onMessage(connectionInfo.id, AIChatMessageEventType.generating);
                }
                // eslint-disable-next-line no-use-before-define
            } else if (dataObj?.type === AIChatBeginResEventKey.chatContentFilter) {
                if (connectionInfo.onMessage) {
                    connectionInfo.onMessage(connectionInfo.id, AIChatMessageEventType.filtered);
                }
            } else if (dataObj?.type === AIChatBeginResEventKey.chatStreamEnd) {
                if (connectionInfo.onMessage) {
                    connectionInfo.onMessage(connectionInfo.id, AIChatMessageEventType.end);
                }
                connectionInfo.eventSource?.close();
                connectionInfo.waitConsumeList.push({
                    status: AIChatMessageResStatus.END,
                });
                if (connectionInfo.onMessage) {
                    connectionInfo.onMessage(connectionInfo.id, AIChatMessageEventType.close);
                }
            }
            // else if (connectionInfo.onMessage) { // 这里是因为模型之前会返回乱七八糟的type
            //     connectionInfo.onMessage(connectionInfo.id, AIChatMessageEventType.error);
            // }
            console.log('social-ai-sse', '=== Message', dataObj, event);
        } catch (err) {
            console.log('social-ai-sse', '[ERROR]解析message错误: ${event.data}');
        }
    };

    private onErrorHandle = (connectionInfo: AIChatConnectionInfo) => (event?: MessageEvent<any>) => {
        // 关闭当前连接
        connectionInfo.eventSource?.close();

        if (connectionInfo.retried) {
            connectionInfo.waitConsumeList.push({
                status: AIChatMessageResStatus.END,
            });
            if (connectionInfo.onMessage) {
                connectionInfo.onMessage(connectionInfo.id, AIChatMessageEventType.error);
            }
            console.log('social-ai-sse', '=== retry but still error', event);
        } else {
            this.sendChatRequest({
                id: connectionInfo.id,
                botId: connectionInfo.botId || '',
                streamingId: connectionInfo.streamingId,
                onMessage: connectionInfo.onMessage,
                isRetry: true,
            });
            console.log('social-ai-sse', '=== go to  retry', event);
        }
    };

    private onExceptionHandle = (connectionInfo: AIChatConnectionInfo) => (event: MessageEvent<any>) => {
        connectionInfo.waitConsumeList.push({
            status: AIChatMessageResStatus.BOT_ERROR,
        });
        connectionInfo.eventSource?.close();
        console.log('social-ai-sse', '==== Exception');
    };
}

export const AIChatHandler = new AIChatConnectionsHandler();
